export default "__VITE_ASSET__erZhX3AA__"